export default __webpack_public_path__ + "static/media/oasis-network-rose-logo.c910dc42.svg";